class NpProductSlider {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.np-product-slide'));
    this.dots = Array.from(el.querySelectorAll('.np-product-slider__dot'));

    this.current = 0;
    this.transitioning = false;

    if (this.slides.length === 0) return;

    this.el.classList.add('np-product-slider--no-transition');
    this._activate(0);
    requestAnimationFrame(() => {
      this.el.classList.remove('np-product-slider--no-transition');
    });

    this._bindDots();
    this._bindArrows();
  }

  _activate(index) {
    const prev = this.current;
    this.current = index;

    this.el.dataset.direction = index > prev ? 'forward' : 'backward';

    this.slides[prev].classList.add('is-prev');
    this.slides[prev].classList.remove('is-active');
    this.slides[index].classList.add('is-active');

    this.slides.forEach((s, i) => {
      if (i !== index && i !== prev) s.classList.remove('is-active', 'is-prev');
    });

    const durationMs =
      (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--slide-duration')) || 0.65) * 1000;

    setTimeout(() => {
      this.slides[prev].style.transition = 'none';
      this.slides[prev].classList.remove('is-prev');
      delete this.el.dataset.direction;
      this.transitioning = false;
      requestAnimationFrame(() => requestAnimationFrame(() => { this.slides[prev].style.transition = ''; }));
    }, durationMs);

    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }

  _goTo(index) {
    if (this.transitioning || index === this.current) return;
    this.transitioning = true;
    this._activate(index);
  }

  _bindDots() {
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this._goTo(i)));
  }

  _bindArrows() {
    const prev = this.el.querySelector('.np-product-slider__arrow--prev');
    const next = this.el.querySelector('.np-product-slider__arrow--next');
    if (prev) prev.addEventListener('click', () => {
      this._goTo((this.current - 1 + this.slides.length) % this.slides.length);
    });
    if (next) next.addEventListener('click', () => {
      this._goTo((this.current + 1) % this.slides.length);
    });
  }
}

document.querySelectorAll('.np-product-slider').forEach((el) => new NpProductSlider(el));
